import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["type", "text", "url", "icon", "name", "style", "children", "clickAction", "childSeoVisibility", "afterClickText", "parent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, Fragment, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useRouter } from 'next/router';
import classnames from 'classnames';
import BlazeButton from '@blaze-react/button';
import { handleLogout } from '@blaze-cms/core-auth-ui';
import { useApolloClient } from '@apollo/client';
import PropTypes, { bool, string } from 'prop-types';
import { useStringTemplate } from '@blaze-cms/utils-handlebars';
import ClickWrapper from './ClickWrapper';
import BlazeLink from './BlazeLink';
import { withTitle } from '../HOC';
import { getClassModifiers } from '../utils';
import { LOGOUT } from '../constants';
import { renderChildren, updateChildrensParent, hasChildren, getClickWrapperOptions } from '../helpers';
const Button = props => {
  const {
      type,
      text,
      url,
      icon,
      name,
      style,
      children,
      clickAction,
      childSeoVisibility,
      afterClickText,
      parent
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const client = useApolloClient();
  const router = useRouter();
  const isLogoutButton = clickAction === LOGOUT;
  const [cookies] = useCookies();
  const {
    blaze_auth: blazeCookie
  } = cookies;
  const [showChildren, setShowChildren] = useState(false);
  const {
    data: [textToUse, afterClickTextToUse, urlToUse]
  } = useStringTemplate(parent, [text, afterClickText, url]);
  useEffect(() => {
    setShowChildren(false);
  }, [router.asPath]);
  const checkIfButtonShouldRender = () => {
    if (isLogoutButton) return !!blazeCookie;
    if (!text && !icon) return false;
    return !!(url || hasChildren(children));
  };
  const logout = async () => {
    await handleLogout(client);
    if (hasChildren(children)) {
      setShowChildren(true);
      return;
    }
    if (!urlToUse) {
      return router.reload();
    }
    window.location.href = urlToUse;
  };
  const handleClick = async () => {
    if (isLogoutButton) await logout();
    if (!url && !isLogoutButton) setShowChildren(!showChildren);
  };
  if (!checkIfButtonShouldRender()) return null;
  const buttonType = !text && icon ? 'icon' : type;
  const modifiers = getClassModifiers(buttonType, _objectSpread({
    icon,
    style
  }, otherProps));
  const currentProps = url ? {
    href: urlToUse,
    title: name
  } : {
    name
  };
  const DynamicButton = url && !isLogoutButton ? BlazeLink : BlazeButton;
  updateChildrensParent(children, parent.itemId, parent.itemEntity);
  const renderedChildren = renderChildren(children, {
    onClose: handleClick
  });
  const {
    shouldUseClickWrapper,
    wrapperProps
  } = getClickWrapperOptions(children, props);
  const Wrapper = shouldUseClickWrapper ? ClickWrapper : Fragment;
  const contentClassName = classnames('button__content', {
    'button__content--show': showChildren
  });
  return /*#__PURE__*/React.createElement(Wrapper, wrapperProps, childSeoVisibility && /*#__PURE__*/React.createElement("div", {
    className: contentClassName
  }, renderedChildren), !childSeoVisibility && showChildren && renderedChildren, /*#__PURE__*/React.createElement(DynamicButton, _extends({
    className: modifiers,
    onClick: handleClick
  }, currentProps), icon && /*#__PURE__*/React.createElement("i", {
    className: icon
  }), showChildren ? afterClickTextToUse : textToUse));
};
Button.propTypes = {
  parent: PropTypes.object,
  clickAction: PropTypes.string,
  text: PropTypes.string,
  afterClickText: string,
  name: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  style: PropTypes.string,
  childSeoVisibility: bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
Button.defaultProps = {
  parent: {},
  clickAction: '',
  text: '',
  afterClickText: '',
  name: '',
  type: '',
  url: null,
  size: '',
  icon: '',
  style: '',
  children: [],
  childSeoVisibility: false
};
export default withTitle(Button);
//# sourceMappingURL=Button.js.map